<div class="page-container">
   <div class="row mt-2" id="headerTitle">
      <div class="col-12 page-title">Home</div>
   </div>
   <div>
      <div class="row mt-4">
         <div class="col-4">
            <div class=" lbl-value">User Name</div>
            <span>
               <span class="pr-1">{{userDetails.firstName}}&nbsp;</span>
               <span>{{userDetails.lastName}}</span>
            </span>
         </div>
         <div class="col-4">
            <div class=" lbl-value">User ID</div>
            <span>
               {{userDetails.id}}
            </span>
         </div>
         <div class="col-4">
            <div class=" lbl-value">Primary Site</div>
            <span>
               {{primarySiteName}}
            </span>
         </div>
      </div>
      <div class="row mt-4">
         <div class="col-11">
            <div class=" lbl-value">Roles</div>
            <div>
               <span *ngFor="let role of roleUniqueArr, index as i">{{role}}
                  <span class="pr-1" *ngIf="i < roleUniqueArr.length - 1"> , </span>
                  <span class="pr-1" *ngIf="i == roleUniqueArr.length - 1"></span>
               </span>
            </div>
         </div>
      </div>

      <div *ngIf="validatedRole" class="row mt-4">
         <div class="col-12">
            <div class="lbl-value">Change Primary Site</div>
            <div>
               <select class="drpdown" [(ngModel)]="primarySite">
                  <option value="">Select</option>
                  <option [value]="site.id" *ngFor="let site of siteList">{{site.name}}</option>
               </select>
               <button mat-raised-button class="addprimarybtn" style="margin-left: 15px; width: 120px;"
                  (click)="changeSite()">Change
                  Site</button>
            </div>
         </div>
      </div>
   </div>
</div>

<app-footer></app-footer>